import { IRootState } from '@/store';
import { ActionTree } from 'vuex';
import { ILieferantenState } from './state';

import { NAME } from './';

import {
    MAPRECHNUNGEN,
    MAPRECHNUNGDETAIL,
    LOADING,
    OFFSET,
    ADDRECHNUNGEN,
    TOTAL_NUMBER_OF_RECORDS,
    MAP_TVS_KUNDEN_FOR_FILTER,
    OFFSET_TVS_KUNDEN,
    TOTAL_NUMBER_OF_RECORDS_TVS_KUNDEN,
    MAP_TVS_KUNDEN,
    LOADING_TVS_KUNDEN,
    ADD_TVS_KUNDEN_LIST,
    MAP_FEHLERHAFTE_RECHNUNGEN,
    ADD_FEHLERHAFTE_RECHNUNGEN,
    MAP_LIEFERANT_DETAILS,
    MAP_MWST_SATZ_LIST,
    MAP_TVS_KUNDE_DETAILS,
    MAP_UNITS_OF_MEASUREMENT
} from './mutations';
import { NEW_ERRORMESSAGES, CLOSE, NEW_SUCESS, NEW_INFO, NEW_MODAL_ERROR } from '@/store/modules/headerNotification/actions';

import { lieferantRechnungService } from '../services/LieferantRechnungService';

import { downloadService } from '@/services/downloadService';
import { i18n } from '@/plugins/i18n';
import { lieferantKundenService } from '@/areas/lieferant/services/LieferantKundenService';
import { HIDE, SHOW } from '@/store/modules/loadingSpinner/actions';
import {
    ADD_LIEFERANTEN_DOKUMENTE,
    LOADING_DOKUMENTE,
    MAP_LIEFERANTEN_DOKUMENTE,
    OFFSET_DOKUMENTE,
    TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE
} from '@/areas/administration/store/mutations';
import { lieferantenDokumentArchivService } from '@/areas/administration/services/LieferantenDokumentArchivService';
import { archivService } from '@/areas/kunde/archiv/services/ArchivService';
import { rechnungService } from '@/services/rechnungService';
import { VetdataInvoiceData } from '@/types/LieferantRechnungFormularDtos';
import { InvoiceSubmissionHelper } from '@/areas/lieferant/utils/RechnungSubmissionHelper';
import { VetdataXmlGenerator } from '@/areas/lieferant/utils/XmlGenerator';
import { lieferantProfilService } from '@/areas/lieferantadministration/services/LieferantProfilService';
import { LieferantStammdatenApiDto } from '@/api-schema';

export const GET_ALL_RECHNUNGEN = 'getLieferantenRechnungen';
export const GET_RECHNUNG_DETAILS = 'getRechnungsDetails';
export const DOWNLOAD_BELEG = 'downloadBelegPdf';
export const GET_ALL_TVS_KUNDEN_VON_LIEFERANT = 'getAllTvsKundenVonLieferant';
export const LOAD_TVS_KUNDEN = 'loadTvsKunden';
export const GET_NEXT_TVS_KUNDE = 'getNextTvsKunde';
export const DOWNLOAD_TVS_KUNDEN_LISTE = 'downloadTvsKundenListe';
export const LOAD_LIEFERANTEN_DOKUMENTE = 'loadLieferantenDokumente';
export const OPEN_DOKUMENT = 'openDokument';
export const DOWNLOAD_DOKUMENT = 'downloadDokument';
export const RETRY_RECHNUNG_PROCESSING = 'retryRechnungProcessing';
export const UPLOAD_FEHLERHAFTE_RECHNUNG_DATEI = 'uploadFehlerhafteRechnungDatei';
export const GET_ALL_FEHLERHAFTE_RECHNUNGEN = 'getLieferantenFehlerhafteRechnungen';
export const DELETE_FEHLERHAFTE_RECHNUNG = 'deleteFehlerhafteRechnung';
export const LOAD_LIEFERANT_DETAILS = 'loadLieferantDetails';
export const EDIT_LIEFERANT_DETAILS = 'editLieferantDetails';
export const LOAD_TVS_KUNDE_DETAILS = 'loadTvsKundenDetails';
export const CLEAR_TVS_KUNDE_DETAILS = 'clearTvsKundenDetails';
export const LOAD_UNITS_OF_MEASUREMENT = 'loadUnitsOfMeasurement';
export const LOAD_MWST_SATZ_LIST = 'loadMwstSatzList';
export const SUBMIT_INVOICE = 'submitInvoice';
export const GET_BENUTZER_BY_ID = 'getLieferantBenutzer';

export const actions: ActionTree<ILieferantenState, IRootState> = {
    [GET_ALL_RECHNUNGEN]({ commit, state, dispatch }: any, offset: number) {
        console.debug(NAME + '::' + GET_ALL_RECHNUNGEN);

        if (state.loading || (offset !== 0 && offset >= state.totalNumberOfRecords)) {
            return;
        }

        if (state.rechnungFilter.rechnungDatumVon != undefined && state.rechnungFilter.rechnungDatumBis != undefined) {
            const dateFrom = new Date(
                state.rechnungFilter.rechnungDatumVon.substring(6, 10) as any,
                state.rechnungFilter.rechnungDatumVon.substring(3, 5) as any,
                state.rechnungFilter.rechnungDatumVon.substring(0, 2) as any
            );
            const dateTo = new Date(
                state.rechnungFilter.rechnungDatumBis.substring(6, 10) as any,
                state.rechnungFilter.rechnungDatumBis.substring(3, 5) as any,
                state.rechnungFilter.rechnungDatumBis.substring(0, 2) as any
            );
            dispatch('headerNotification/' + CLOSE, {}, { root: true });
            if (dateFrom > dateTo) {
                dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.impossible.date') }, { root: true });
                return;
            }
        }

        if (state.rechnungFilter.betragBis != undefined && state.rechnungFilter.betragVon != undefined) {
            const betragBis = parseFloat(state.rechnungFilter.betragBis as string);
            const betragVon = parseFloat(state.rechnungFilter.betragVon as string);

            if (betragBis < betragVon) {
                console.debug('Invalid amount range:', {
                    from: betragVon,
                    to: betragBis
                });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    {
                        errorMessages: i18n.global.t('errormessage.impossible.betrag')
                    },
                    { root: true }
                );
                return;
            }
        }

        commit(LOADING, true);
        commit(OFFSET, offset);
        lieferantRechnungService.getAll(state.rechnungFilter).then((response) => {
            if (!offset || offset < 1) {
                commit(TOTAL_NUMBER_OF_RECORDS, response.totalNumberOfRecords);
                commit(MAPRECHNUNGEN, response.entries);
            } else {
                commit(ADDRECHNUNGEN, response.entries);
            }
            commit(LOADING, false);
        });
    },
    [GET_RECHNUNG_DETAILS]({ commit, state }: any, xmlDokumentGuid: string) {
        console.debug(NAME + '::' + GET_RECHNUNG_DETAILS);
        state.rechnungenDetails = [];

        lieferantRechnungService.getDetails(xmlDokumentGuid).then((response) => {
            commit(MAPRECHNUNGDETAIL, response);
        });
    },
    [DOWNLOAD_BELEG]({ commit }: any, { id, defaultFileName }: any) {
        console.debug(NAME + '::' + DOWNLOAD_BELEG);

        lieferantRechnungService.downloadBeleg(id).then((response) => {
            downloadService.downloadFile(response, defaultFileName);
        });
    },
    [GET_ALL_TVS_KUNDEN_VON_LIEFERANT]({ commit }: any) {
        console.debug(NAME + '::' + GET_ALL_TVS_KUNDEN_VON_LIEFERANT);
        lieferantRechnungService.getTvsKundenVonLieferant().then((response) => {
            commit(MAP_TVS_KUNDEN_FOR_FILTER, response);
        });
    },
    async [LOAD_TVS_KUNDEN]({ commit, state }: any) {
        console.debug(NAME + '::' + LOAD_TVS_KUNDEN);

        if (state.tvsKundenLoading || (state.tvsKundenFilter.offset !== 0 && state.tvsKundenFilter.offset >= state.tvsKundenTotalNumberOfRecords)) {
            return;
        }
        commit(LOADING_TVS_KUNDEN, true);
        commit(OFFSET_TVS_KUNDEN, 0);

        await lieferantKundenService.getTvsKunden(state.tvsKundenFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TVS_KUNDEN, response.totalNumberOfRecords);
            commit(MAP_TVS_KUNDEN, response.entries);
            commit(LOADING_TVS_KUNDEN, false);
        });
    },
    async [GET_NEXT_TVS_KUNDE]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_NEXT_TVS_KUNDE);

        if (state.tvsKundenLoading || (state.tvsKundenFilter.offset !== 0 && state.tvsKundenFilter.offset >= state.tvsKundenTotalNumberOfRecords)) {
            return;
        }
        commit(LOADING_TVS_KUNDEN, true);
        commit(OFFSET_TVS_KUNDEN, state.tvsKundenListe.length);

        await lieferantKundenService.getTvsKunden(state.tvsKundenFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TVS_KUNDEN, response.totalNumberOfRecords);
            commit(ADD_TVS_KUNDEN_LIST, response.entries);
            commit(LOADING_TVS_KUNDEN, false);
        });
    },
    [DOWNLOAD_TVS_KUNDEN_LISTE]({ dispatch, state }: any, { dokumentName }: any) {
        console.debug(NAME + '::' + DOWNLOAD_TVS_KUNDEN_LISTE);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        lieferantKundenService.downloadTvsKunden(state.tvsKundenFilter).then((response) => {
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            downloadService.downloadFile(response, dokumentName);
        });
    },
    [LOAD_LIEFERANTEN_DOKUMENTE]({ commit, state, dispatch }: any, offset: number) {
        console.debug(NAME + '::' + LOAD_LIEFERANTEN_DOKUMENTE, offset);

        if (state.dokumenteLoading || (offset !== 0 && offset >= state.lieferantenDokumenteTotalNumberOfRecords)) {
            return;
        }

        if (state.lieferantenDokumentFilter.dateFrom != undefined && state.lieferantenDokumentFilter.dateTo != undefined) {
            const dateFrom = new Date(
                state.lieferantenDokumentFilter.dateFrom.substring(6, 10) as any,
                state.lieferantenDokumentFilter.dateFrom.substring(3, 5) as any,
                state.lieferantenDokumentFilter.dateFrom.substring(0, 2) as any
            );
            const dateTo = new Date(
                state.lieferantenDokumentFilter.dateTo.substring(6, 10) as any,
                state.lieferantenDokumentFilter.dateTo.substring(3, 5) as any,
                state.lieferantenDokumentFilter.dateTo.substring(0, 2) as any
            );
            dispatch('headerNotification/' + CLOSE, {}, { root: true });
            if (dateFrom > dateTo) {
                dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.impossible.date') }, { root: true });
                return;
            }
        }

        commit(LOADING_DOKUMENTE, true);
        commit(OFFSET_DOKUMENTE, offset);

        const searchQuery = Object.assign({}, state.lieferantenDokumentFilter);
        if (searchQuery.dokumentKategorie === '') {
            searchQuery.dokumentKategorie = null;
        }
        if (searchQuery.teilnehmerId === '') {
            searchQuery.teilnehmerId = null;
        }

        lieferantenDokumentArchivService.getAll(searchQuery).then((response) => {
            if (!offset || offset < 1) {
                commit(TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE, response.totalNumberOfRecords);
                commit(MAP_LIEFERANTEN_DOKUMENTE, response.entries);
            } else {
                commit(ADD_LIEFERANTEN_DOKUMENTE, response.entries);
            }
            commit(LOADING_DOKUMENTE, false);
        });
    },
    [OPEN_DOKUMENT]({ commit }: any, { id, dateiTyp, dokumentName }: any) {
        console.debug(NAME + '::' + OPEN_DOKUMENT);

        lieferantenDokumentArchivService.downloadDokument(id).then((response) => {
            downloadService.openOrDownloadFile(response, dokumentName, ['image/jpeg', 'image/png', 'application/pdf']);
        });
    },
    [DOWNLOAD_DOKUMENT]({ commit }: any, { id, dokumentName }: any) {
        console.debug(NAME + '::' + DOWNLOAD_DOKUMENT);

        archivService.downloadDokument(id).then((response) => {
            downloadService.downloadFile(response, 'placeholder');
        });
    },
    [RETRY_RECHNUNG_PROCESSING]({ dispatch, commit }: any, tvsLieferantRechnungId: string) {
        console.debug(NAME + '::' + RETRY_RECHNUNG_PROCESSING);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        return rechnungService
            .retryProcessing(tvsLieferantRechnungId)
            .then((response) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN, 0);
                console.debug('retryProcessing response:', response);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                // Check if the operation was successful
                if (response.isSuccess === false) {
                    // Translate error codes to user-friendly messages
                    const errorMessages =
                        response.errors?.map((errorCode: string) => i18n.global.t(errorCode)).join(', ') ||
                        i18n.global.t('errormessage.processing.retry.failed');
                    dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages }, { root: true });
                    return response;
                }
                // Success case
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('processing.retry.success') }, { root: true });
                return response;
            })
            .catch((error) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN, 0);
                console.error('retryProcessing error:', error);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    { errorMessages: error.message || i18n.global.t('errormessage.processing.retry.failed') },
                    { root: true }
                );
            });
    },
    [UPLOAD_FEHLERHAFTE_RECHNUNG_DATEI]({ dispatch, state }: any, { file, tvsLieferantRechnungId }: { file: File; tvsLieferantRechnungId: string }) {
        console.debug(NAME + '::' + UPLOAD_FEHLERHAFTE_RECHNUNG_DATEI);

        if (file.size === 0) {
            dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.upload.documentsizezero') }, { root: true });
            return;
        }

        const validTypes = ['application/pdf', 'text/xml', 'application/xml'];
        if (!validTypes.includes(file.type)) {
            dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.upload.invalidfiletype') }, { root: true });
            return;
        }

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        rechnungService
            .uploadFehlerhafteRechnungDatei(tvsLieferantRechnungId, file)
            .then((response) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN, 0);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });

                // Check if response is success or error
                if (response.isSuccess === false) {
                    // Translate error codes to messages
                    const errorMessages =
                        response.errors?.map((errorCode: string) => i18n.global.t(errorCode)).join(', ') || i18n.global.t('errormessage.upload.failed');
                    dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages }, { root: true });
                    return response;
                }

                // Success case
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('upload.erfolgreich') }, { root: true });
                return response;
            })
            .catch((error) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN, 0);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    { errorMessages: error.message || i18n.global.t('errormessage.upload.failed') },
                    { root: true }
                );
            });
    },
    [GET_ALL_FEHLERHAFTE_RECHNUNGEN]({ commit, state, dispatch }: any, offset: number) {
        console.debug(NAME + '::' + GET_ALL_FEHLERHAFTE_RECHNUNGEN);

        if (state.loading || (offset !== 0 && offset >= state.totalNumberOfRecords)) {
            return;
        }

        if (state.rechnungFilter.rechnungDatumVon != undefined && state.rechnungFilter.rechnungDatumBis != undefined) {
            const dateFrom = new Date(
                state.rechnungFilter.rechnungDatumVon.substring(6, 10) as any,
                state.rechnungFilter.rechnungDatumVon.substring(3, 5) as any,
                state.rechnungFilter.rechnungDatumVon.substring(0, 2) as any
            );
            const dateTo = new Date(
                state.rechnungFilter.rechnungDatumBis.substring(6, 10) as any,
                state.rechnungFilter.rechnungDatumBis.substring(3, 5) as any,
                state.rechnungFilter.rechnungDatumBis.substring(0, 2) as any
            );
            dispatch('headerNotification/' + CLOSE, {}, { root: true });
            if (dateFrom > dateTo) {
                dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('errormessage.impossible.date') }, { root: true });
                return;
            }
        }

        commit(LOADING, true);
        commit(OFFSET, offset);
        rechnungService.getAllFehlerhafteRechnungen(state.rechnungFilter).then((response) => {
            if (!offset || offset < 1) {
                commit(TOTAL_NUMBER_OF_RECORDS, response.totalNumberOfRecords);
                commit(MAP_FEHLERHAFTE_RECHNUNGEN, response.entries);
            } else {
                commit(ADD_FEHLERHAFTE_RECHNUNGEN, response.entries);
            }
            commit(LOADING, false);
        });
    },
    [DELETE_FEHLERHAFTE_RECHNUNG]({ dispatch, commit }: any, tvsLieferantRechnungId: string) {
        console.debug(NAME + '::' + DELETE_FEHLERHAFTE_RECHNUNG);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        return rechnungService
            .deleteFeherhafteRechnung(tvsLieferantRechnungId)
            .then((response) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN, 0);
                console.debug('deleteRechnung response:', response);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('rechnung.fehlerhaft.delete.erfolgreich') }, { root: true });
                return response;
            })
            .catch((error) => {
                dispatch(GET_ALL_FEHLERHAFTE_RECHNUNGEN, 0);
                console.error('deleteRechnung error:', error);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                dispatch(
                    'headerNotification/' + NEW_ERRORMESSAGES,
                    { errorMessages: error.message || i18n.global.t('errormessage.delete.failed') },
                    { root: true }
                );
            });
    },
    [LOAD_LIEFERANT_DETAILS]({ commit }: any, lieferantenNummer: string) {
        console.debug(NAME + '::' + LOAD_LIEFERANT_DETAILS);

        return new Promise((resolve) => {
            lieferantProfilService.loadLieferantDetails(lieferantenNummer).then((response) => {
                commit(MAP_LIEFERANT_DETAILS, response);
                resolve(response);
            });
        });
    },
    [EDIT_LIEFERANT_DETAILS]({ dispatch }: any, { lieferant, lieferantennummer }: { lieferant: LieferantStammdatenApiDto; lieferantennummer: string }) {
        console.debug(NAME + '::' + EDIT_LIEFERANT_DETAILS, lieferant);

        return lieferantProfilService.requestEditLieferantDetails(lieferant, lieferantennummer).then((response) => {
            if (response) {
                dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('einstellungen.success.editLieferantDetails') }, { root: true });
            }
        });
    },
    async [LOAD_TVS_KUNDE_DETAILS]({ dispatch, commit }: any, suchText: string) {
        console.debug(NAME + '::' + LOAD_TVS_KUNDE_DETAILS);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        try {
            const response = await lieferantRechnungService.getTvsKundeDetails(suchText);
            commit(MAP_TVS_KUNDE_DETAILS, response);
            dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('einstellungen.findtvskunde.success') }, { root: true });
        } catch (error: any) {
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            // TVS Kunde wurde nicht gefunden, Error abfangen
            if (error.response && error.response.status === 404) {
                dispatch('headerNotification/' + NEW_INFO, { text: i18n.global.t('einstellungen.findtvskunde.tvsKundeNotFound') }, { root: true });
            } else {
                dispatch('headerNotification/' + NEW_INFO, { text: i18n.global.t('einstellungen.findtvskunde.unexpectedError') }, { root: true });
            }
            return;
        }
        dispatch('loadingSpinner/' + HIDE, {}, { root: true });
    },
    async [CLEAR_TVS_KUNDE_DETAILS]({ dispatch, commit, state }: any) {
        console.debug(NAME + '::' + CLEAR_TVS_KUNDE_DETAILS);
        state.tvsKundeDetails = null;
    },
    async [LOAD_UNITS_OF_MEASUREMENT]({ dispatch, commit }: any) {
        console.debug(NAME + '::' + LOAD_UNITS_OF_MEASUREMENT);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        try {
            const response = await lieferantRechnungService.getUnitsOfMeasurement(i18n.global.locale);

            // Alphabetisch sortieren
            const sortedResponse = [...response].sort((a, b) => a.text.localeCompare(b.text, i18n.global.locale));
            commit(MAP_UNITS_OF_MEASUREMENT, sortedResponse);
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
        } catch (error: any) {
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_MODAL_ERROR, { text: i18n.global.t('einstellungen.unitsOfMeasurement.loadError') }, { root: true });
            console.error('Error loading units of measurement:', error);
            throw error;
        }
    },
    async [LOAD_MWST_SATZ_LIST]({ dispatch, commit }: any) {
        console.debug(NAME + '::' + LOAD_MWST_SATZ_LIST);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });

        try {
            const response = await lieferantRechnungService.getMwstSatzList();
            commit(MAP_MWST_SATZ_LIST, response);
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
        } catch (error: any) {
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_MODAL_ERROR, { text: i18n.global.t('einstellungen.vatRates.loadError') }, { root: true });
            console.error('Error loading VAT rates:', error);
            throw error;
        }
    },
    async [SUBMIT_INVOICE]({ dispatch }: any, { invoiceData, pdfFile, formData }: { invoiceData: VetdataInvoiceData; pdfFile: File; formData: any }) {
        console.debug(NAME + '::' + SUBMIT_INVOICE);

        // 1. Pre-validation
        const validation = InvoiceSubmissionHelper.validateInvoiceData(invoiceData);
        if (!validation.valid) {
            dispatch('headerNotification/' + NEW_ERRORMESSAGES, { errorMessages: i18n.global.t('lieferanten.rechnungformular.fehlerhaft') }, { root: true });
            return;
        }

        // 2. Generate XML
        const xmlGenerator = new VetdataXmlGenerator();
        const xmlString = xmlGenerator.generateXml(invoiceData);

        // 3. Build request
        const request = await InvoiceSubmissionHelper.buildSubmissionRequest(xmlString, pdfFile, formData);

        // 4. Submit
        await lieferantRechnungService.submitInvoice(request);

        dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('lieferanten.rechnungformular.erfolgreich') }, { root: true });

        return { success: true };
    }
};
